import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { BoundCoordinates } from '../../models/map.model';
import { PropertyListModel } from '../../models/property-list.model';
import { MapService } from '../../services/map.service';
import { RouterModule } from '@angular/router';
import { ApiImagePipe } from '../../pipes/image.pipe';
import { SearchResultModel } from '../../models/search-result.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SettingsModel } from '../../models/setting.model';

@Component({
  selector: 'app-search-property-list',
  templateUrl: './search-property-list.component.html',
  styleUrls: ['./search-property-list.component.scss'],
  imports: [RouterModule, ApiImagePipe, MatTooltipModule],
  standalone: true,
})
export class SearchPropertyListComponent implements OnInit {
  @Input() properties: PropertyListModel[] = [];
  @Input() searchResult: SearchResultModel = new SearchResultModel();
  @Input() settings: SettingsModel = new SettingsModel();
  filteredProperties: PropertyListModel[] = [];

  boundCoordinates: BoundCoordinates = new BoundCoordinates();

  containerHeight = 500;
  constructor(
    private mapService: MapService,
    @Inject(PLATFORM_ID) private platformID: Object,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformID))
      this.containerHeight = window.innerHeight - 140;
  }

  openWindow(propertyId: number) {
    const property =
      this.properties.find((x) => x.Id === propertyId) ??
      new PropertyListModel();

    this.mapService.setMarkedProperty(property);
  }

  getRatingArray(rating: number) {
    return new Array(rating).fill(0).map((n, index) => index + 1);
  }
}
